import { useEffect, useRef } from 'react'

export function useViewTracker(
  ref: React.RefObject<Element>,
  callback: () => void,
  options: IntersectionObserverInit = { threshold: 0.1 },
) {
  const hasFired = useRef(false)

  useEffect(() => {
    const el = ref.current
    if (!el || hasFired.current) return
    if (typeof IntersectionObserver === 'undefined') {
      return
    }
    const obs = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && !hasFired.current) {
          callback()
          hasFired.current = true
          obs.disconnect()
        }
      }
    }, options)

    obs.observe(el)
    return () => obs.disconnect()
  }, [ref, callback, options])
}
